import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BokkzAlgDataService, BokkzVpbDataService, BokkzVpbLogic} from "@snelstart-ventures/fiscaal/domain-logic";


@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-belastingbedrag',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-belastingbedrag.component.html',
  styleUrl: './tekst-belastingbedrag.component.scss',
})
export class TekstBelastingbedragComponent {

  constructor(
      public dataService: BokkzVpbDataService,
      public vpbService: BokkzVpbLogic,
      public algDataService: BokkzAlgDataService,
  ) {
  }

}
